import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import styleClasses from "./RegistrationForm.module.css";
import formClasses from "../forms/Forms.module.css";
import EventContext from "../../store/EventContext";

import UserInfoContext from "../../store/UserInfoContext";

import Button from "../Button";
import RegisterButton from "./RegisterButton";
import CheckoutContext from "../../store/CheckoutContext";

import { SpinningCircles } from "react-loading-icons";
import { IconContext } from "react-icons";
import { CiCirclePlus } from "react-icons/ci";
import { IoCloseCircleOutline } from "react-icons/io5";

const MTI_MAPAAsphaltTrack = () => {
  const eventCtx = useContext(EventContext);
  const userCtx = useContext(UserInfoContext);
  const checkoutCtx = useContext(CheckoutContext);

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState();
  const [submitMessage, setSubmitMessage] = useState();
  const [didComplete, setDidComplete] = useState();

  const [payMethod, setPayMethod] = useState();

  const [inputName, setInputName] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputRegLevel, setInputRegLevel] = useState("");
  const [inputError, setInputError] = useState("");

  const [attendees, setAttendees] = useState([]);

  const { format } = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const getPrice = (regLevel) => {
    switch (regLevel) {
      case "MDOT":
        return eventCtx.selectedEvent.price_obj.regFee.MDOTEmployee;
      case "Member":
        return eventCtx.selectedEvent.price_obj.regFee.Member;
      case "Non-Member":
        return eventCtx.selectedEvent.price_obj.regFee.NonMember;
      default:
        break;
    }
  };

  const grandTotal = (atts) => {
    let total = 0;
    atts.forEach((att) => (total += +att.price));
    return total;
  };

  const AttendeeInfoInputs = () => {
    return (
      <div
        className={`${formClasses.gridFourCol} ${formClasses.gridContainer}`}
      >
        <input
          value={inputName}
          type="text"
          placeholder="Name"
          onChange={(e) => setInputName(e.target.value)}
        />

        <input
          value={inputEmail}
          type="text"
          placeholder="Email"
          onChange={(e) => setInputEmail(e.target.value)}
        />
        <select
          value={inputRegLevel}
          name="reg-levels"
          id="reg-level"
          onChange={(e) => setInputRegLevel(e.target.value)}
        >
          <option value="">- -Registration- -</option>
          <option value="MDOT">MDOT Employee</option>
          <option value="Member">Member</option>
          <option value="Non-Member">Non Member</option>
        </select>
        <div>
          <IconContext.Provider
            value={{ size: "2em", style: { padding: "0" } }}
          >
            <CiCirclePlus
              style={{ color: "#FFA559" }}
              onClick={() => {
                const currentAttendeeEntry = {
                  name: inputName,
                  email: inputEmail,
                  regLevel: inputRegLevel,
                  price: getPrice(inputRegLevel),
                };
                if (inputRegLevel && inputName && inputEmail) {
                  setAttendees((prev) => [...prev, currentAttendeeEntry]);
                  setInputError("");
                } else {
                  setInputError("Please enter all information for Attendee");
                }
                setInputName("");
                setInputEmail("");
                setInputRegLevel(false);
              }}
            />
          </IconContext.Provider>
        </div>
      </div>
    );
  };
  const formatAttendees = (attendees) => {
    console.log(attendees);
    let customObj = {};
    attendees.forEach((att) => {
      customObj[`${att.name}`] =
        `Email: ${att.email} | Registration: ${att.regLevel}`;
    });
    return customObj;
  };
  // console.log(attendees)
  return (
    <div className={styleClasses.page}>
      <h2>{eventCtx.selectedEvent.event_date_obj.dates}</h2>
      <h4 className={styleClasses.disclaimer}>
        Attendees will receive 3 PDH hours
      </h4>

      <h4 className={styleClasses.disclaimer}>
        You can make your reservations at the Beau Rivage Resort & Casino
        <a
          className={styleClasses.disclaimer}
          href={eventCtx.selectedEvent.custom_info_obj.reservationURL}
          target="blank"
          rel="noopener"
        >
          <b> here.</b>
        </a>
        &nbsp;Last day to make reservations is{" "}
        {eventCtx.selectedEvent.custom_info_obj.reservationLastDay}
      </h4>

      <h4 className={styleClasses.disclaimer}>
        Private Reception to follow immediately after track for MDOT employees
        and asphalt track attendees only.
      </h4>
      <section
        className={`${styleClasses.section} ${styleClasses.borderOrange}`}
      >
        <div
          className={`${styleClasses.backgroundOrange} ${styleClasses.headingBackground}`}
        >
          <h3>Attendees</h3>
        </div>
        <table
          className={`${styleClasses.table} ${styleClasses.flex} ${styleClasses.center} ${styleClasses.leftAlign}`}
        >
          <tbody>
            <tr>
              <th>MDOT Employee</th>
              <td>
                {format(eventCtx.selectedEvent.price_obj.regFee.MDOTEmployee)}
              </td>
            </tr>
            <tr>
              <th>MAPA Member</th>
              <td>{format(eventCtx.selectedEvent.price_obj.regFee.Member)}</td>
            </tr>
            <tr>
              <th>Non Member</th>
              <td>
                {format(eventCtx.selectedEvent.price_obj.regFee.NonMember)}
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        {attendees.map((attendee, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center" }}>
            <IconContext.Provider value={{ size: "30px", color: "#ffa559" }}>
              <IoCloseCircleOutline
                onClick={() => {
                  setAttendees((prev) => prev.filter((att, i) => i !== index));
                }}
              />
            </IconContext.Provider>
            <div
              className={`${styleClasses.infoCard}`}
              style={{ width: "100%" }}
            >
              <p>
                <b>Name:</b> {attendee["name"]}
              </p>
              <p>
                <b>Email:</b> {attendee["email"]}
              </p>
              <p>
                <b>Registration:</b> {attendee["regLevel"]}
              </p>
              <p>
                <b>Price:</b> {format(attendee["price"])}
              </p>
            </div>
          </div>
        ))}
        <br />
        {AttendeeInfoInputs()}
        {<p style={{ color: "#ffa559", textAlign: "center" }}>{inputError}</p>}
        {
          <h2 style={{ textAlign: "left" }}>
            Attendee Total:&nbsp;{format(grandTotal(attendees))}
          </h2>
        }
      </section>
      <br />
      {/* <h3>For more information:</h3> */}
      {/* <a
        href={`https://yplstzafkrlvgcnssbfi.supabase.co/storage/v1/object/public/event_storage/${eventCtx.selectedEvent.event_attachment_filename}`}
        target="about_blank"
      >
        Download the PDF registration packet
      </a> */}
      <br />
      <br />
      <br />
      {isLoading ? (
        <SpinningCircles stroke="#ffffff30" fill="#FFF" speed="1.0" />
      ) : (
        submitMessage
      )}
      {!didComplete && (
        <RegisterButton
          isDisabled={attendees.length === 0}
          setIsLoading={setIsLoading}
          setSubmitMessage={setSubmitMessage}
          didComplete={setDidComplete}
          registrantData={{
            eventID: eventCtx.selectedEvent.id,
            event: eventCtx.selectedEvent,
            company: userCtx.company,
            firstName: userCtx.firstName,
            lastName: userCtx.lastName,
            address: `${userCtx.street} ${userCtx.city} ${userCtx.state} ${userCtx.zip}`,
            email: userCtx.email,
            phone: userCtx.phone,
            customInputs: formatAttendees(attendees),
          }}
        />
      )}
      {didComplete && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "5em",
          }}
        >
          <h2>Pay Method:</h2>
          <div
            className={styleClasses.checkbox}
            style={{ marginBottom: "2em" }}
          >
            <input
              type="radio"
              name="pay-method"
              value="Check"
              onChange={() => setPayMethod("Check")}
            />
            <label htmlFor="pay-method">Check</label>
            <input
              type="radio"
              name="pay-method"
              value="Card"
              onChange={() => setPayMethod("Card")}
            />
            <label htmlFor="pay-method">Card</label>
          </div>
          {payMethod === "Check" && (
            <div style={{ marginBottom: "5em" }}>
              <h3>Please Mail Check to:</h3>
              <p style={{ margin: "0", textAlign: "center" }}>
                Mississippi Asphalt Pavement Association
              </p>
              <p style={{ margin: "0", textAlign: "center" }}>
                711 N. Presidents St.
              </p>
              <p style={{ margin: "0", textAlign: "center" }}>
                Jackson, MS 39202
              </p>
            </div>
          )}
          {payMethod && (
            <Button
              backgroundColor={"#FFA559"}
              shadowColor={"#454545"}
              title={payMethod === "Check" ? "Okay" : "Proceed to Checkout"}
              onClick={() => {
                if (payMethod === "Check") {
                  navigate("/");
                } else {
                  attendees.forEach((attendee) => {
                    checkoutCtx.addItem({
                      itemName: `MTI - ${attendee.name} ${attendee.regLevel}`,
                      itemPrice: attendee.price,
                    });
                  });
                  navigate("/checkout");
                }
                console.log("Set Item object and nav to Checkout");
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MTI_MAPAAsphaltTrack;
